import localStorage from 'r/utils/localStorage';
import {IS_COLOR_THEME_DARK as localStorageKey} from '../KEYS';

const defaultValue = false;

export default class StoredIsColorThemeDark {
  static get() {
    return JSON.parse(localStorage.getItem(localStorageKey)) || defaultValue;
  }

  static set(value) {
    localStorage.setItem(localStorageKey, JSON.stringify(value));
  }
}
